const slowOrigins = new Map()
const RETRY_AFTER_MS = 30000
const MAX_ORIGINS = 8

const originOf = value => {
  try { return new URL(value).origin } catch { return null }
}

// This stores delivery timing only, never image bytes or access credentials.
export function ShouldUseBoqImageProxy(url, now = Date.now()) {
  const origin = originOf(url)
  const retryAt = slowOrigins.get(origin)
  if (!retryAt) return false
  if (retryAt <= now) {
    slowOrigins.delete(origin)
    return false
  }
  return true
}

export function MarkBoqImageCdnSlow(url, now = Date.now()) {
  const origin = originOf(url)
  if (!origin) return
  if (!slowOrigins.has(origin) && slowOrigins.size >= MAX_ORIGINS) {
    slowOrigins.delete(slowOrigins.keys().next().value)
  }
  slowOrigins.set(origin, now + RETRY_AFTER_MS)
}

export function MarkBoqImageCdnHealthy(url) {
  slowOrigins.delete(originOf(url))
}
